
import { Component, Vue } from 'vue-property-decorator'
import { getRoutes, getRoles, createRole, deleteRole, updateRole } from '../../api/roles'
import { CourseModule } from '../../store/modules/course'

@Component({
  name: 'role'
})
export default class extends Vue {
  list: any = []
  dialogVisible: boolean = false
  dialogType: string = 'new'
  role: any = {
    name: '',
    desc: ''
  }
  checkStrictly: boolean = false
  routesTreeData: any = []
  defaultProps: any = {
    children: 'children',
    label: 'label'
  }
  expandedKeys: any = []
  checkedKeys: any = []
  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  rolesList: any = [
      { id: '1', roles: [] },
      { id: '2', roles: [], children: [{ id: '2-1', roles: [] }, { id: '2-2', roles: [] }, { id: '2-3', roles: [] }] },
      { id: '3', roles: [], children: [{ id: '3-1', roles: [] }, { id: '3-2', roles: [] }, { id: '3-3', roles: [] }, { id: '3-4', roles: [] }, { id: '3-5', roles: [] }] },
      { id: '4', roles: [], children: [{ id: '4-1', roles: [] }, { id: '4-2', roles: [] }, { id: '4-3', roles: [] }] },
      { id: '5', roles: [], children: [{ id: '5-1', roles: [] }, { id: '5-2', roles: [] }, { id: '5-3', roles: [] }] },
      { id: '6', roles: [], children: [{ id: '6-1', roles: [] }, { id: '6-2', roles: [] }, { id: '6-3', roles: [] }, { id: '6-4', roles: [] }] },
      { id: '7', roles: [], children: [{ id: '7-1', roles: [] }, { id: '7-2', roles: [] }, { id: '7-3', roles: [] }] },
      { id: '8', roles: [], children: [{ id: '8-1', roles: [] }, { id: '8-2', roles: [] }, { id: '8-3', roles: [] }, { id: '8-4', roles: [] }, { id: '8-5', roles: [] }] },
      { id: '9', roles: [], children: [{ id: '9-1', roles: [] }, { id: '9-2', roles: [] }, { id: '9-3', roles: [] }, { id: '9-4', roles: [] }, { id: '9-5', roles: [] }] },
      { id: '10', roles: [], children: [{ id: '10-1', roles: [] }, { id: '10-2', roles: [] }, { id: '10-3', roles: [] }, { id: '10-4', roles: [] }] }
  ]
  roleType: string = 'admin'
  item_id: string = ''

  mounted() {
    // Mock: get all routes and roles list from server
    this.getRoleInfo()
    this.routesTreeData = [
      {
        id: '1',
        label: '首页'
      },
      {
        id: '2',
        label: '课程中心',
        children: [
          {
            id: '2-1',
            label: '课程表'
          },
          {
            id: '2-2',
            label: '正式课签到记录'
          },
          {
            id: '2-3',
            label: '试听课签到记录'
          }
        ]
      },
      {
        id: '3',
        label: '客户中心',
        children: [
          {
            id: '3-1',
            label: '学员管理'
          },
          {
            id: '3-2',
            label: '商机管理'
          },
          {
            id: '3-3',
            label: '客户管理'
          },
          {
            id: '3-4',
            label: '线索池'
          },
          {
            id: '3-5',
            label: '订单管理'
          }
        ]
      },
      {
        id: '4',
        label: '人员管理',
        children: [
          {
            id: '4-1',
            label: '人员数据排名'
          },
          {
            id: '4-2',
            label: '人员管理'
          },
          {
            id: '4-3',
            label: '角色管理'
          }
        ]
      },
      {
        id: '5',
        label: '物品管理',
        children: [
          {
            id: '5-1',
            label: '出售物品管理'
          },
          {
            id: '5-2',
            label: '服役物品管理'
          },
          {
            id: '5-3',
            label: '仓储物品管理'
          }
        ]
      },
      {
        id: '6',
        label: '平台管理',
        children: [
          {
            id: '6-1',
            label: '校区管理'
          },
          {
            id: '6-2',
            label: '日志管理'
          },
          {
            id: '6-3',
            label: '短信管理'
          },
          {
            id: '6-4',
            label: '问题反馈'
          }
        ]
      },
      {
        id: '7',
        label: '教学管理',
        children: [
          {
            id: '7-1',
            label: '教学要点设置'
          },
          {
            id: '7-2',
            label: '教学主题设置'
          },
          {
            id: '7-3',
            label: '教学素材设置'
          }
        ]
      },
      {
        id: '8',
        label: '课程设置',
        children: [
          {
            id: '8-1',
            label: '课程种类设置'
          },
          {
            id: '8-2',
            label: '课程等级设置'
          },
          {
            id: '8-3',
            label: '主题等级设置'
          },
          {
            id: '8-4',
            label: '课程套餐设置'
          },
          {
            id: '8-5',
            label: '课程列表管理'
          }
        ]
      },
      {
        id: '9',
        label: '基础设置',
        children: [
          {
            id: '9-1',
            label: '乐器类型设置'
          },
          {
            id: '9-2',
            label: '学员等级设置'
          },
          {
            id: '9-3',
            label: '客户来源设置'
          },
          {
            id: '9-4',
            label: '教师等级设置'
          },
          {
            id: '9-5',
            label: '物品类型设置'
          }
        ]
      },
      {
        id: '10',
        label: '学生端设置',
        children: [
          {
            id: '10-1',
            label: '轮播图设置'
          },
          {
            id: '10-2',
            label: '文章设置'
          },
          {
            id: '10-3',
            label: '帮助设置'
          },
          {
            id: '10-4',
            label: '关于我们设置'
          }
        ]
      }
    ]
  }

  async getRoleInfo() {
    const res: any = await getRoles(this.org_id)
    if (res.code === 200) {
      this.list = res.data.page_section[0].entity.entity_data
    }
  }

  getRolesList() {
    this.rolesList = [
      { id: '1', roles: [] },
      { id: '2', roles: [], children: [{ id: '2-1', roles: [] }, { id: '2-2', roles: [] }, { id: '2-3', roles: [] }] },
      { id: '3', roles: [], children: [{ id: '3-1', roles: [] }, { id: '3-2', roles: [] }, { id: '3-3', roles: [] }, { id: '3-4', roles: [] }, { id: '3-5', roles: [] }] },
      { id: '4', roles: [], children: [{ id: '4-1', roles: [] }, { id: '4-2', roles: [] }, { id: '4-3', roles: [] }] },
      { id: '5', roles: [], children: [{ id: '5-1', roles: [] }, { id: '5-2', roles: [] }, { id: '5-3', roles: [] }] },
      { id: '6', roles: [], children: [{ id: '6-1', roles: [] }, { id: '6-2', roles: [] }, { id: '6-3', roles: [] }, { id: '6-4', roles: [] }] },
      { id: '7', roles: [], children: [{ id: '7-1', roles: [] }, { id: '7-2', roles: [] }, { id: '7-3', roles: [] }] },
      { id: '8', roles: [], children: [{ id: '8-1', roles: [] }, { id: '8-2', roles: [] }, { id: '8-3', roles: [] }, { id: '8-4', roles: [] }, { id: '8-5', roles: [] }] },
      { id: '9', roles: [], children: [{ id: '9-1', roles: [] }, { id: '9-2', roles: [] }, { id: '9-3', roles: [] }, { id: '9-4', roles: [] }, { id: '9-5', roles: [] }] },
      { id: '10', roles: [], children: [{ id: '10-1', roles: [] }, { id: '10-2', roles: [] }, { id: '10-3', roles: [] }, { id: '10-4', roles: [] }] }
    ]
  }

  async deletePeople(val) {
    const res: any = await deleteRole(val.id)
    if (res.code === 200) {
      this.$message({
        type: 'success',
        message: '删除成功!'
      })
      this.getRoleInfo()
    } else {
      this.$message.error('删除失败！')
    }
  }

  async handleDelete(val) {
    this.$confirm('是否确认删除角色?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.deletePeople(val)
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '取消删除'
      })
    })
  }

  closeRoles() {
    this.dialogVisible = false
  }

  handleEdit(val) {
    this.item_id = val.id
    this.role.name = val.name
    this.role.desc = val.desc
    this.checkedKeys = []
    this.expandedKeys = []
    this.getRolesList()
    const content = JSON.parse(val.content)
    this.createTree(content)
    this.dialogType = 'edit'
    this.dialogVisible = true
  }

  handleCreateRole() {
    this.role = {
      name: '',
      desc: ''
    }
    // this.checkedKeys = ['1']
    this.checkedKeys = ['1', '2', '2-1', '2-2', '2-3', '3', '3-1', '3-2', '3-3', '3-4', '3-5', '4', '4-1','4-2','4-3', '5', '5-1', '5-2', '5-3', '6', '6-1', '6-2', '6-3', '6-4', '7', '7-1', '7-2', '7-3', '8', '8-1', '8-2', '8-3', '8-4', '8-5', '9', '9-1', '9-2', '9-3', '9-4', '9-5', '10', '10-1', '10-2', '10-3', '10-4' ]
    this.expandedKeys = []
    this.getRolesList()
    this.createTree(this.rolesList)
    this.dialogType = 'new'
    this.dialogVisible = true
  }

  createTree(content) {
    for (var i = 0; i < content.length; i++) {
      if (content[i].children) {
        for (var j = 0; j < content[i].children.length; j++) {
          if (content[i].children[j].roles.length > 0) {
            this.expandedKeys.push(content[i].id)
            this.checkedKeys.push(content[i].children[j].id)
          }
        }
      } else {
        if (content[i].roles.length > 0) {
          this.checkedKeys.push(this.routesTreeData[i].id)
        }
      }
    }
  }

  async confirmRole() {
    const nodes = (this.$refs.tree as any).getCheckedKeys()
    for (var j = 0; j < this.rolesList.length; j++) {
      if (this.rolesList[j].children) {
        for (var i = 0; i < this.rolesList[j].children.length; i++) {
          if (nodes.indexOf(this.rolesList[j].children[i].id) >= 0) {
            this.rolesList[j].roles = [this.roleType]
            this.rolesList[j].children[i].roles = [this.roleType]
          }
        }
      } else {
        if (nodes.indexOf(this.rolesList[j].id) >= 0) {
          this.rolesList[j].roles = [this.roleType]
        }
      }
    }
    if (!this.role.name) {
      this.$message({
        message: '请输入角色名称',
        type: 'warning'
      })
      return false
    }
    if (!this.role.desc) {
      this.$message({
        message: '请输入角色描述',
        type: 'warning'
      })
      return false
    }
    if (nodes.length === 0) {
      this.$message({
        message: '请勾选角色权限',
        type: 'warning'
      })
      return false
    }
    let data = {
      data: {
        name: this.role.name,
        desc: this.role.desc,
        content: JSON.stringify(this.rolesList)
      }
    }

    if (this.dialogType === 'edit') {
      data['data_id'] = this.item_id
      const res: any = await updateRole(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '编辑成功!'
        })
        this.dialogVisible = false
        this.getRoleInfo()
      } else {
        this.$message.error('编辑失败！')
      }
    } else if (this.dialogType === 'new') {
      const res: any = await createRole(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '添加成功!'
        })
        this.dialogVisible = false
        this.getRoleInfo()
      } else {
        this.$message.error('添加失败！')
      }
    }

    this.closeRoles()
  }
}
